
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"18","viewBox":"0 0 10 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.5 3.294H9v-.47a.457.457 0 00-.146-.333.516.516 0 00-.354-.138c-.133 0-.26.05-.354.138A.457.457 0 008 2.824v.47h-.5c-.133 0-.26.05-.354.138A.457.457 0 007 3.765c0 .125.053.244.146.332.094.089.221.138.354.138H8v.47c0 .126.053.245.146.334.094.088.221.137.354.137.133 0 .26-.05.354-.137A.457.457 0 009 4.706v-.47h.5c.133 0 .26-.05.354-.139A.457.457 0 0010 3.765a.457.457 0 00-.146-.333.516.516 0 00-.354-.138zm-3.85.81c.267-.218.48-.487.627-.789.147-.302.223-.63.223-.962 0-.624-.263-1.223-.732-1.664A2.581 2.581 0 004 0c-.663 0-1.299.248-1.768.69A2.285 2.285 0 001.5 2.352c0 .332.076.66.223.962.146.302.36.571.627.789-.7.298-1.294.78-1.71 1.387A3.606 3.606 0 000 7.53c0 .125.053.245.146.333C.24 7.95.367 8 .5 8c.133 0 .26-.05.354-.138A.457.457 0 001 7.53c0-.748.316-1.467.879-1.996A3.098 3.098 0 014 4.706c.796 0 1.559.297 2.121.827.563.53.879 1.248.879 1.996 0 .125.053.245.146.333.094.088.221.138.354.138.133 0 .26-.05.354-.138A.457.457 0 008 7.53c0-.723-.223-1.43-.64-2.038a3.942 3.942 0 00-1.71-1.387zM4 3.764c-.297 0-.587-.082-.833-.237a1.434 1.434 0 01-.553-.634 1.335 1.335 0 01-.085-.815c.058-.274.2-.526.41-.723.21-.198.477-.332.768-.387.291-.054.593-.026.867.08.274.107.508.288.673.52.165.233.253.506.253.785 0 .374-.158.733-.44.998A1.549 1.549 0 014 3.765z","fill":"#D8F3DC"}})])
          )
        }
      }
    